import {Injectable} from "@angular/core";
import {IService} from "../IService";
import {PromotionCampaignTypeModel} from "../../models/promotion-campaign-type.model";
import {HttpClientService} from "../httpClient/httpclient.service";
import {PromotionMessageTypeModel} from "../../models/promotion-message-type.model";

@Injectable()
export class PromotionMessageTypeService extends IService<PromotionMessageTypeModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'message-type')
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-message-type.service.ts